<template>
<div>
    <h2>邀请函</h2>
    <h3>(长按图片保存)</h3>
    <img src="//cdn.edstatic.com/203012120000/7d7b95fe721bb84fb7e258bed50f1a9b/2022/11/c0e71ca3-d736-4fcf-9ede-9b5596fd0944.jpeg">
    <h2>学会文件</h2>
    <h3>(长按图片保存)</h3>
    <img src="//cdn.edstatic.com/203012120000/9469b212d98ccec20191752554ad85f5/2022/11/0efe5dd3-d786-4f44-85db-8f81aa932db4.png">
</div>
</template>

<script>
import {ButtonDetail} from '../../config/interface.js'
export default {
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
    methods:{
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
    }
}
</script>

<style scoped>
h2{
    text-align: center;
    line-height: 30px;
    margin-top: 20px;
}
h3{
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;

}
img{
    width: 100%;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/invite.vue